import React, { useState } from 'react';
import { TabsOption } from 'global';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';

import { DealSheetRuleForm } from './rule';
import { RulesTableContainer } from './table';

export const DealSheet = () => {
  const [pageView, setPageView] = useState<'tabs' | 'create'>('tabs');

  const tabs: TabsOption[] = [
    {
      value: 'rulesList',
      label: 'Business Rule',
      component: <RulesTableContainer onCreateRule={() => setPageView('create')} />,
    },
    {
      isVisible: false,
      value: 'configuration',
      label: 'Configuration',
      component: <>Configuration</>,
    },
  ];

  const render = {
    tabs: <TabsContainer tabs={tabs} />,
    create: <DealSheetRuleForm onCancel={() => setPageView('tabs')} />,
  };

  return render[pageView];
};
